export default {
  "root": "_root_136xx_1",
  "input": "_input_136xx_1",
  "--size-medium": "_--size-medium_136xx_1",
  "--size-large": "_--size-large_136xx_1",
  "--size-xlarge": "_--size-xlarge_136xx_1",
  "--variant-faded": "_--variant-faded_136xx_1",
  "--variant-headless": "_--variant-headless_136xx_1",
  "--status-error": "_--status-error_136xx_1",
  "--resize-auto": "_--resize-auto_136xx_1",
  "--resize-none": "_--resize-none_136xx_1",
  "--size-medium--m": "_--size-medium--m_136xx_1",
  "--size-large--m": "_--size-large--m_136xx_1",
  "--size-xlarge--m": "_--size-xlarge--m_136xx_1",
  "--size-medium--l": "_--size-medium--l_136xx_1",
  "--size-large--l": "_--size-large--l_136xx_1",
  "--size-xlarge--l": "_--size-xlarge--l_136xx_1",
  "--size-medium--xl": "_--size-medium--xl_136xx_1",
  "--size-large--xl": "_--size-large--xl_136xx_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_136xx_1"
};import "ni:sha-256;RXjALSqfbzosDBu2_Jl-Xm-uPv-p1hYMIJoTLe-dlUM";